import { useContext } from 'react';
import { AlertServiceContext } from "../components/AlertProvider/types";

export const useAlertService = () => {
    const context = useContext(AlertServiceContext);
    if (!context) {
        throw new Error('useAlertService must be used within an AlertServiceProvider');
    }
    return context;
};
